import { useQuery } from "@tanstack/react-query";
import { getLeagueWithTranslations } from "@/api/leaguesNew";
import { LeaguesNewQueryKeys } from "./leaguesNewQueryKeys";

export const useLeagueWithTranslations = (id: number | undefined) => {
  return useQuery({
    queryKey: [LeaguesNewQueryKeys.LeagueWithTranslations, id],
    queryFn: () => getLeagueWithTranslations(id!),
    enabled: !!id,
    staleTime: 0,
  });
};
